import React,{ useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation,useNavigate } from "react-router-dom";
import { updatePayment } from "../../features/userSlice";
import { msgAccessPromt } from "../../constant/constant";
const PaymentStatus = React.memo(({getpay}) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const dispatch=useDispatch();

  const fetchPayment=async(txnId)=>{
      let dataSet = new FormData();  
      
      
      dataSet.append('TRANS_ID',txnId);
      const data = await dispatch(updatePayment(dataSet)).unwrap();
      if(data.status===true){
        msgAccessPromt({dispatch,error:false,msg:data.message});
      }else if(data.message==='Your Payment is pending please wait'){
        msgAccessPromt({dispatch,error:false,msg:data.message});
      }else{
        msgAccessPromt({dispatch,error:true,msg:data.message});
      }
              
      navigate("/");
  }
  
  
  
  useEffect(()=>{
  if (queryParams.has("trans_id")) {
    const transId = queryParams.get("trans_id");
  fetchPayment(transId);
  } 
  },[]);


  return <div>
 

  </div>;
});

export default PaymentStatus;
